import React from "react";
const ApplauseIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.247 7.533 4.746 4.49s-.94-.783-1.826.167c-.197.21-.288.435-.339.63-.12.461.073.948.446 1.244l3.61 2.859-2.488-1.973s-.647-.51-1.325.171c-.55.552-.747 1.206.266 2.073l3.58 3.007s3.844 2.701 6.374-.832c1.36-1.901.122-1.806.451-6.802 0 0-.01-1.13-1.223-1.13s-1.035 2.823-1.035 2.823L6.792 3.153s-.916-.743-1.6 0c-.845.917.09 1.772.09 1.772l2.965 2.608Z"
          stroke="#000"
          strokeWidth=".677"
          fill="#FFD60B"
        />
        <path
          d="M6.215 5.817 2.714 2.775s-.94-.783-1.826.167c-.197.21-.288.434-.34.63-.12.461.074.948.447 1.243l3.61 2.86-2.489-1.973s-.647-.51-1.324.171c-.55.552-.747 1.206.266 2.073l3.579 3.007s3.844 2.701 6.374-.832c1.362-1.901.123-1.806.452-6.802 0 0-.01-1.13-1.223-1.13-1.214 0-1.035 2.823-1.035 2.823L4.76 1.437s-.916-.743-1.6 0c-.845.917.09 1.772.09 1.772l2.965 2.608Z"
          fill="#975F00"
        />
        <path
          d="M8.247 7.533 4.746 4.49s-.94-.783-1.826.167c-.197.21-.288.435-.339.63-.12.461.073.948.446 1.244l3.61 2.859-2.488-1.973s-.647-.51-1.325.171c-.55.552-.747 1.206.266 2.073l3.58 3.007s3.844 2.701 6.374-.832c1.36-1.901.122-1.806.451-6.802 0 0-.01-1.13-1.223-1.13s-1.035 2.823-1.035 2.823L6.792 3.153s-.916-.743-1.6 0c-.845.917.09 1.772.09 1.772l2.965 2.608Z"
          stroke="#975F00"
          strokeWidth=".677"
          fill="#FFD60B"
        />
        <path
          stroke="#29ABE2"
          strokeWidth=".677"
          strokeLinecap="round"
          d="M10.387.339v.79M11.9 1.59 12.938.555M8.873 1.591 7.836.554"
        />
      </g>
    </svg>
  )
);
ApplauseIcon.displayName = "ApplauseIcon";
export default ApplauseIcon;
